import { IdleObserverSettings } from './idleObserverSettings';

/**
 *
 */
export class IdleObserver {
  private timer;
  private controller = new AbortController();
  private readonly settings: IdleObserverSettings;

  /**
   *
   */
  constructor(settings: IdleObserverSettings) {
    this.settings = settings;

    this.settings.root.addEventListener('mousemove', (event) => this.handleEvent(event), {
      passive: true,
      capture: true,
      signal: this.controller.signal,
    });
    this.settings.root.addEventListener('keydown', (event) => this.handleEvent(event), {
      passive: true,
      capture: true,
      signal: this.controller.signal,
    });
    // console.debug('IdleObserver event listeners registered', this.settings);

    this.start();
  }

  stop() {
    this.controller.abort();
    clearTimeout(this.timer);
  }

  /**
   *
   * @private
   */
  start() {
    // console.debug('timer started')
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.trigger(), this.settings.idleTimeMillis);
  }

  /**
   *
   * @private
   */
  private trigger() {
    // console.debug('call trigger');
    // only trigger once, so remove listener and timeout
    if (this.settings.once) {
      this.stop();
    }

    if (this.settings.callback) {
      this.settings.callback.call(this);
    }

    if (!this.settings.once) {
      this.start();
    }
  }

  /**
   *
   * @param event
   * @private
   */
  private handleEvent(event: Event) {
    if (this.settings.ignoredEvents.includes(event.type)) {
      return;
    }
    // console.debug('restart timer');
    this.start();
  }
}
